'use client';

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GlobalProvider } from "./context/GlobalContext";
// import { useEffect } from "react";
// import NProgress from "nprogress";
// import { usePathname } from "next/navigation";
import "nprogress/nprogress.css";
import GlobalLoader from "./GlobalLoader";

const queryClient = new QueryClient();

export default function Providers({ children }: { children: React.ReactNode }) {

    // const pathname = usePathname();

    // useEffect(() => {
    //     NProgress.start();
    //     NProgress.done();
    // }, [pathname]);

    return (
        <QueryClientProvider client={queryClient}>
            <GlobalProvider>
                <GlobalLoader />
                {children}</GlobalProvider>
        </QueryClientProvider>
    );
}
